import apiClient from './client';
import { getUserId } from '../analytics';

const buildRequestHeaders = (token = null) => {
  const headers = {};
  const uid = getUserId();
  if (uid) headers['X-User-ID'] = uid;
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

export const getMondialiCountries = async (token = null) => {
  const response = await apiClient.get('/mondiali/countries', {
    headers: buildRequestHeaders(token),
  });
  return response.data;
};

export const createMondialiRegistration = async (payload, token = null) => {
  const response = await apiClient.post('/mondiali/registrations', payload, {
    headers: buildRequestHeaders(token),
  });
  return response.data;
};

export const updateMondialiRegistrationUsername = async (payload, token = null) => {
  const response = await apiClient.patch('/mondiali/registrations/me/username', payload, {
    headers: buildRequestHeaders(token),
  });
  return response.data;
};

export const getMondialiRegistrations = async (token = null) => {
  const response = await apiClient.get('/mondiali/registrations', {
    headers: buildRequestHeaders(token),
  });
  return response.data;
};

export const getMondialiRegistrationsSummary = async (token = null) => {
  const response = await apiClient.get('/mondiali/registrations/summary', {
    headers: buildRequestHeaders(token),
  });
  return response.data;
};

export const getMondialiLeaderboardForRange = async ({ startAt, endAt }, token = null) => {
  const response = await apiClient.get('/mondiali/leaderboards/range', {
    headers: buildRequestHeaders(token),
    params: {
      start_at: startAt,
      end_at: endAt,
    },
  });
  return response.data;
};

export const getMondialiFinaleLeaderboard = async ({ startAt, endAt } = {}, token = null) => {
  const params = {};
  if (startAt) params.start_at = startAt;
  if (endAt) params.end_at = endAt;

  const response = await apiClient.get('/mondiali/leaderboards/finale', {
    headers: buildRequestHeaders(token),
    params,
  });
  return response.data;
};

export const getMondialiTopPlayerLeaderboard = async ({ startAt, endAt } = {}, token = null) => {
  const params = {};
  if (startAt) params.start_at = startAt;
  if (endAt) params.end_at = endAt;

  const response = await apiClient.get('/mondiali/leaderboards/top-player', {
    headers: buildRequestHeaders(token),
    params,
  });
  return response.data;
};
